export default __webpack_public_path__ + "static/media/videomb.0e19946f.mp4";